import React from 'react'
import './Home.css'

const Home = () => {
  return (
    <main className="home">
      <section className="games-section">
        <div className="container">
          <h2 className="games-title">Discover our games</h2>
          <div className="games-store-link">
            <a
              href="https://play.google.com/store/apps/dev?id=6633244980219000886"
              target="_blank"
              rel="noopener noreferrer"
              className="store-badge"
            >
              <img
                src="/assets/images/google-play-badge.png"
                alt="Get it on Google Play"
              />
            </a>
          </div>
        </div>
      </section>
    </main>
  )
}

export default Home
